<template>
  <div id="home" class="page-slide">
    <transition name="page-slide-1">
      <BackgroundVideo src="/assets/videos/bg.mp4" v-show="show" />
    </transition>
    <transition name="page-slide-1">
      <PartnerLayout :partners="['IBM', 'Amazon', 'Microsoft', 'Nvidia', 'Startup in Residence of Desjardins']" v-show="show" class="margin-bottom delay" />
    </transition>
    <transition name="page-slide-1">
      <Carousel v-show="show" />
    </transition>
  </div>
</template>

<script>
import BackgroundVideo from "./BackgroundVideo";
import PartnerLayout from "./PartnerLayout";
import Carousel from "./Carousel";

export default {
  name: "PageSlideHome",
  components: { BackgroundVideo, PartnerLayout, Carousel },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.page-slide {
  background-color: $background-color-secondary-2;
  .margin-bottom {
    margin-bottom: 35px;
  }
}

.page-slide-1-enter-active,
.page-slide-1-leave-active {
  transition-property: opacity;
  transition-duration: $page-slide-transition-duration;
  transition-timing-function: $page-slide-transition-timing-function;
}

.page-slide-1-enter-active {
  &.delay {
    transition-delay: $partner-layout-transition-delay;
  }
}

.page-slide-1-leave-active {
  transition-delay: 0;
}

.page-slide-1-enter,
.page-slide-1-leave-to {
  transition-delay: 0;
  opacity: 0;
}
</style>
